import LangSelector from './components/lang-selector';
import CatalogLoadMore from './components/catalog-load-more';
import CatalogSearchForm from './components/catalog-search-form';
import SiteHeader from './components/site-header';
import PartnersSlider from './components/partners-slider';
import ImageHotspotsSelector from './components/image-hotspots-selector';
import HandheldMenu from "./components/handheld-menu";
import CookiesConsent from "./components/cookies-consent";
import DropdownMenu from "./components/dropdown-menu";
import Accordion from "./components/accordion";
import HotspotsSlider from "./components/hotspots-slider";
import SlidesSection from "./components/slides-section";
import ProductsSlider from "./components/products-slider";
import ProductsSorting from "./components/products-sorting";
import ProductImagesGallery from "./components/product-images-gallery";

import DeviceManager from './utils/device-manager';

(function($) {
    window.$ = $;
    const lang = typeof pro.lang !== 'undefined' ? pro.lang : 'en';

    $(function() {
        const $html = $('html');

        // Touch device detection
        if(DeviceManager.isHandheld()) {
            $html.addClass('touch');

            if(DeviceManager.isIos()) {
                $html.addClass('ios');
            }
        }
        else {
            $html.addClass('no-touch');
        }

        // IE detection
        if(DeviceManager.isIe11()) {
            $html.addClass('ie11');
        }
        else if(DeviceManager.isEdge()) {
            $html.addClass('edge');
        }

        // Handheld menu
        const handheldMenu = new HandheldMenu();

        // General components
        const langSelector = new LangSelector($('.language-selector'));
        const siteHeader = new SiteHeader($('.site-header'), 250);
        //const dropdownMenu = new DropdownMenu($('.header__nav'));

        // Partners slider component
        const $partnersSliders = $('.partners-slider');
        if($partnersSliders.length) {
            $partnersSliders.each(function(index, el) {
                let partnerSlider = new PartnersSlider($(el));
            });
        }

        // Slides section component
        const $slidesSection = $('.slides-slider');
        if($slidesSection.length) {
            $slidesSection.each(function(index, el) {
                let slidesSection = new SlidesSection($(el));
            });
        }

        // Product list component
        const $sliderProducts = $('.products-list__wrapper');
        if($sliderProducts.length) {
            $sliderProducts.each(function(index, el) {
                let sliderProducts = new ProductsSlider($(el));
            });
        }

        // Product images gallery component
        const $productImagesGallery = $('.product-details__images-gallery');
        if($productImagesGallery.length) {
            $productImagesGallery.each(function(index, el) {
                let productImagesGallery = new ProductImagesGallery($(el));
            });
        }

        // Image with hotspots component
        const $imagesWithHotspots = $('.image-hotspots-selector');
        if($imagesWithHotspots.length) {
            $imagesWithHotspots.each(function(index, el) {
                let imageWithHotspots = new ImageHotspotsSelector($(el));
            });
        }

        // Catalog load more component
        const $catalogLoadMoreBtns = $('.results-list__load-more-link');
        if($catalogLoadMoreBtns.length) {
            $catalogLoadMoreBtns.each(function(index, el) {
                let catalogLoadMore = new CatalogLoadMore($(el));
            });
        }
        
        // Catalog search form component
        const $catalogSearchForms = $('.catalog-search');
        if($catalogSearchForms.length) {
            $catalogSearchForms.each(function(index, el) {
                let catalogSearchForm = new CatalogSearchForm($(el));
            });
        }

        // Cookie consent
        if(typeof tarteaucitron !== 'undefined' && tarteaucitron) {
            // Tarteaucitron cookie settings
            let tarteaucitronLang = lang || 'en';

            if(lang === 'cn') {
                tarteaucitronLang = 'en';
            }

            const cookiesConsent = new CookiesConsent(tarteaucitronLang);
        }
    });

    if (window.matchMedia("(max-width: 991px)").matches) {
        $('.slider-mobile').flickity({
            autoPlay: true,
            pageDots: false,
            wrapAround: true,
            prevNextButtons: false
        });
    }

    $('.main-menu__toggle-submenu-arrow').on('click', (e) => {
        e.preventDefault();

        const target = e.currentTarget;
        target.parentNode.classList.toggle('menu-item--opened');
    });

})(jQuery);
